import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../services/api';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        // Lấy refresh token để gửi tới server
        const refreshToken = localStorage.getItem('refreshToken');
        
        if (refreshToken) {
          // Gọi API đăng xuất để vô hiệu hóa refresh token ở server
          await logout({ refreshToken });
        }
      } catch (error) {
        console.error('Lỗi khi đăng xuất:', error);
      } finally {
        // Dọn dẹp dữ liệu người dùng
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('token'); // Xóa cả token cũ
        localStorage.removeItem('user');
        
        // Chuyển hướng về trang chủ
        navigate('/');
        window.location.reload(); // Làm mới trang để cập nhật trạng thái
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Đang đăng xuất...</span>
        </div>
        <h3>Đang đăng xuất...</h3>
      </div>
    </div>
  );
};

export default Logout;